var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container"},[_c('StrategyReport')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }